<template>
  <div class="mine_invoice">
    <div class="mine_invoice_header">
      <span>{{$t('Mine.myInvoice')}}</span>
    </div>
    <!-- nav复用： -->
    <div class="mine_order_nav">
      <div class="mine_order_nav_ul">
        <div class="father_item" v-for="item in mineOrderList" :key="item.id">
          <div
            :class="['father_item_inner', whoHighlight === item.id? 'active': '']"
            @click="handleMineOrderItem(item)"
          >{{lang === 'zh'? item.title: item.titleEN}}</div>
        </div>
        <div class="ul_underline" ref="ulUnderline"></div>
      </div>
    </div>
    <!-- invoice main: -->
    <div class="mine_invoice_body">
      <div class="mine_invoice_body_header">
        <div class="mine_invoice_body_inner_date">{{$t('Mine.date')}}</div>
        <div class="mine_invoice_body_inner_unit">{{$t('Mine.unit')}}</div>
        <div class="mine_invoice_body_inner_money">{{$t('Mine.money')}}</div>
        <div class="mine_invoice_body_inner_operation">{{$t('Mine.operation')}}</div>
      </div>
      <div class="mine_invoice_body_content">
        <!-- some of one : -->
        <div class="mine_invoice_body_content_inner_some_of_one" v-for="item in 6" :key="item" v-show="false">
          <div class="p_l_15 mine_invoice_body_inner_date">2019-11-10</div>
          <div class="p_l_15 mine_invoice_body_inner_unit">上海市某某公司</div>
          <div class="p_l_15 mine_invoice_body_inner_money">120.00</div>
          <div class="p_l_15 mine_invoice_body_inner_operation">
            <van-button type="danger" size="small">{{$t('Mine.toMakeOutAnInvoice')}}</van-button>
          </div>
        </div>
      </div>
      <!-- empty: -->
      <div class="mine_order_father_box_empty">
        <img src="../../../assets/img/empty/wait.png" class="w_50">
        <p>{{$t('Mine.haveNoData')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mineOrderList: [
        {
          title: "我的消费",
          titleEN: "My spending",
          id: 0,
          left: 0
        },
        {
          title: "已开发票",
          titleEN: "Have make out",
          id: 1,
          left: 160
        }
      ],
      whoHighlight: 0
    };
  },
  computed: {
    lang: function() {
      return this.$i18n.locale;
    }
  },
  methods: {
    handleMineOrderItem(val) {
      this.$refs.ulUnderline.style.left = `${val.left}px`;
      this.whoHighlight = val.id;
    }
  }
};
</script>

<style lang="scss" scoped>
.mine_invoice {
  padding-bottom: 50px;
  .mine_invoice_header {
    height: 50px;
    text-align: left;
    margin-left: 100px;
    margin-right: 100px;
    line-height: 50px;
    border-bottom: 1px solid #ddd;
    color: #bababa;
    font-weight: 700;
    color: #000;
  }
  .mine_order_nav {
    margin-top: 20px;
    height: 40px;
    background-color: #fafafa;
    margin-left: 100px;
    margin-right: 100px;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
    .mine_order_nav_ul {
      display: flex;
      position: relative;
      .father_item {
        width: 160px;
        height: 40px;
        .father_item_inner {
          width: 80px;
          height: 40px;
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          &.active {
            color: #52a1ca;
          }
        }
      }
      .ul_underline {
        height: 3px;
        width: 80px;
        background-color: #52a1ca;
        position: absolute;
        bottom: 0px;
        left: 0px;
        transition: all 0.3s;
      }
    }
  }
  .mine_invoice_body {
    margin-left: 100px;
    margin-right: 100px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    margin-top: 20px;
    .mine_invoice_body_header {
      display: flex;
      height: 40px;
      line-height: 40px;
      text-align: left;
      background-color: #fafafa;
      border-bottom: 1px solid #ddd;
      div {
        padding-left: 15px;
      }
    }
    .mine_invoice_body_content {
      background-color: green;
      .mine_invoice_body_content_inner_some_of_one {
        height: 45px;
        display: flex;
        text-align: left;
        align-items: center;
        .p_l_15 {
          padding-left: 15px;
        }
      }
    }
  }
}
.mine_invoice_body_inner_date {
  flex: 2;
}
.mine_invoice_body_inner_unit {
  flex: 4;
}
.mine_invoice_body_inner_money {
  flex: 1;
}
.mine_invoice_body_inner_operation {
  flex: 1;
}
.mine_order_father_box_empty {
  padding: 30px 0;
}
</style>